'use client';

import { useIntl } from 'react-intl';
import {
  PriceDiscount,
  type PriceDiscountProps,
} from '@packages/shared/src/ui/Price/PriceDiscount/PriceDiscount';
import { priceDiscountMessages } from './messages';

type PriceDiscountLocalizedProps = Omit<
  PriceDiscountProps,
  'oldPriceAriaLabel' | 'discountAriaLabel' | 'allowStrikethrough'
> & {
  oldPriceType: 'msrp' | undefined;
};

export const PriceDiscountLocalized = (props: PriceDiscountLocalizedProps) => {
  const { formatMessage } = useIntl();

  const { oldPriceType, ...rest } = props;

  return (
    <PriceDiscount
      {...rest}
      allowStrikethrough={oldPriceType !== 'msrp'}
      oldPriceAriaLabel={formatMessage(priceDiscountMessages.originalPrice)}
      discountAriaLabel={formatMessage(priceDiscountMessages.discount)}
    />
  );
};
